import React, {useState} from 'react';
import {useNavigate} from "react-router-dom";
import * as AppStore from "../../redux/app";
import {useDispatch} from "react-redux";
import {useTonConnectModal, useTonWallet} from "@tonconnect/ui-react";
import {toast} from "react-toastify";
import toastOptions from "../../data/ToastOptions";
import DisclaimerModal from "../disclaimer";
import Modal from "../modal";
import ModalTask from "./ModalTask";

const DailyTasksNotDone = ({item, index, type, setRefresh}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { open } = useTonConnectModal();
    const wallet = useTonWallet();
    const [showModal, setShowModal] = useState(false);

    const saveIdFn = (section) => {
        let doneTasksIdPrev = JSON.parse(localStorage.getItem('doneTaskIds')) ?? []
        doneTasksIdPrev = [Number(item.id), ...doneTasksIdPrev]
        localStorage.setItem('doneTaskIds', JSON.stringify(doneTasksIdPrev))

        if (section === 'hi_jet') {
            dispatch(AppStore.actions.setHomeState(false))
            navigate('/');
        } else if (section === 'wallet_connect') {
            if (!!wallet) {
                toast.success('Your wallet already connected!', {...toastOptions, toastId: 6});
            } else {
                open();
            }
        }
    }

    const openModal = () => {
        setShowModal(true);
    }
    const closeModal = (val) => {
        setShowModal(false);
        if (val === 'withSubmit') {
            setRefresh();
        }
    }

    if (item?.task_type === 'app_section') {
        return (
            <button type="button" key={Math.random().toString()} className={`tasks-taskItem tasks-taskItem-btn notDone pointer ${type === 'daily' ? 'tasks-dailyStyle' : ''}`} onClick={() => saveIdFn(item?.url)}>
                {item?.icon && <img alt="Jace Tapp" src={item?.icon} className="tasks-icon" />}
                {!item?.icon && <p className="tasks-bigNumber">{index + 1}</p>}
                <div className="tasks-textContainer">
                    <p className="tasks-taskTitle lineNumber1">{item?.title ?? '-'}</p>
                    {/*<p className="tasks-taskDescription lineNumber1">{item?.url ?? '-'}</p>*/}
                </div>
                <div className={`tasks-status notDoneStatus column center ${type === 'daily' ? 'tasks-customPaddingDaily' : ''}`}>
                    <p className="text-white fs14 font-bold lineNumber1 text-center">{`${item?.point} JETs`}</p>
                    <p className="text-white fs12 font-normal lineNumber1 text-center">{item?.is_done ? 'Well Done!' : 'Do & Earn'}</p>
                </div>
            </button>
        );
    }

    if (item?.task_type === 'modal') {
        return (
            <div className="w100">
                <button type="button" key={Math.random().toString()} className={`tasks-taskItem tasks-taskItem-btn notDone pointer ${type === 'daily' ? 'tasks-dailyStyle' : ''}`} onClick={openModal}>
                    {item?.icon && <img alt="Jace Tapp" src={item?.icon} className="tasks-icon" />}
                    {!item?.icon && <p className="tasks-bigNumber">{index + 1}</p>}
                    <div className="tasks-textContainer">
                        <p className="tasks-taskTitle lineNumber1">{item?.title ?? '-'}</p>
                        {/*<p className="tasks-taskDescription lineNumber1">{item?.url ?? '-'}</p>*/}
                    </div>
                    <div className={`tasks-status notDoneStatus column center ${type === 'daily' ? 'tasks-customPaddingDaily' : ''}`}>
                        <p className="text-white fs14 font-bold lineNumber1 text-center">{`${item?.point} JETs`}</p>
                        <p className="text-white fs12 font-normal lineNumber1 text-center">{item?.is_done ? 'Well Done!' : 'Do & Earn'}</p>
                    </div>
                </button>
                <Modal isOpen={showModal} onClose={closeModal}>
                    <ModalTask item={item} onClose={closeModal} />
                </Modal>
            </div>
        );
    }

    return (
        <a href={item.url} target="_blank" rel="noopener noreferrer" key={Math.random().toString()} className={`tasks-taskItem notDone ${type === 'daily' ? 'tasks-dailyStyle' : ''}`} onClick={saveIdFn}>
            {item?.icon && <img alt="Jace Tapp" src={item?.icon} className="tasks-icon" />}
            {!item?.icon && <p className="tasks-bigNumber">{index + 1}</p>}
            <div className="tasks-textContainer">
                <p className="tasks-taskTitle lineNumber1">{item?.title ?? '-'}</p>
                <p className="tasks-taskDescription lineNumber1">{item?.url ?? '-'}</p>
            </div>
            <div className={`tasks-status notDoneStatus column center ${type === 'daily' ? 'tasks-customPaddingDaily' : ''}`}>
                <p className="text-white fs14 font-bold lineNumber1 text-center">{`${item?.point} JETs`}</p>
                <p className="text-white fs12 font-normal lineNumber1 text-center">{item?.is_done ? 'Well Done!' : 'Do & Earn'}</p>
            </div>
        </a>
    )
};

export default DailyTasksNotDone;
